export default __webpack_public_path__ + "static/media/wa_nonactive.a64ff90b.svg";